var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.206 30C35.1297 30 37.5 32.2385 37.5 35C37.5 37.7615 35.1297 40 32.206 40H26.5C24.6144 40 23.6716 40 23.0858 39.4143C22.5 38.8285 22.5 37.8855 22.5 36V30M32.206 30C35.1297 30 37.5 27.7615 37.5 25C37.5 22.2386 35.1297 20 32.206 20H26.5C24.6144 20 23.6716 20 23.0858 20.5858C22.5 21.1716 22.5 22.1144 22.5 24V30M32.206 30H22.5",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30C52.2385 30 50 27.7615 50 25V20C50 11.7267 48.2732 10 40 10H20C11.7267 10 10 11.7267 10 20V25C10 27.7615 7.76143 30 5 30",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30C7.76143 30 10 32.2385 10 35V40C10 48.2732 11.7267 50 20 50H40C48.2732 50 50 48.2732 50 40V35C50 32.2385 52.2385 30 55 30",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.0b484b000a6df1d8a4d38d636d366120.svg";
export { ForwardRef as ReactComponent };